import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import BrickHeader from "@/components/BrickHeader";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(username, password);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F4F4F4] flex flex-col" data-testid="login-page">
      <BrickHeader />
      <div className="flex-1 flex items-start sm:items-center justify-center px-4 py-10 sm:py-16">
        <div className="w-full max-w-md bg-white border border-[#E2E2E2] rounded-2xl p-6 sm:p-10">
          <h1 className="font-heading text-2xl sm:text-3xl text-[#E6017D]">Anmeldung</h1>
          <p className="text-sm text-[#5F6368] mt-2">
            Bitte melde dich an, um das Bautagebuch zu öffnen.
          </p>

          <form onSubmit={onSubmit} className="mt-8 space-y-5">
            <div className="space-y-2">
              <Label htmlFor="username" className="text-[#5F6368]">Benutzername</Label>
              <Input
                id="username"
                data-testid="login-username-input"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
                className="h-11 bg-white border-[#E2E2E2]"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="text-[#5F6368]">Passwort</Label>
              <Input
                id="password"
                type="password"
                data-testid="login-password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                className="h-11 bg-white border-[#E2E2E2]"
              />
            </div>

            {error && <p data-testid="login-error" className="text-sm text-[#D11A2A]">{error}</p>}

            <Button
              type="submit"
              data-testid="login-submit-button"
              disabled={loading}
              className="w-full h-11 bg-[#E6017D] hover:bg-[#C4016A] text-white transition-colors"
            >
              {loading ? <Loader2 className="animate-spin" size={18} /> : "Anmelden"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
